// スクロールに合わせてheader-shippingを隠す
$(function() {
  let currentPosition = 0;
  const headerShipping = document.querySelector(".header-shipping");
  const main = document.querySelector(".main");

  // スクロールに合わせて要素を移動（表示域から隠す）
  window.addEventListener("scroll", () => {
    
    let scrollPosition = document.documentElement.scrollTop;

    // 検索入力時になぜかheaderShippingが表示されてしまうため、その対策
    // 検索入力時にscrollPositionが0になるため、その時は何もしない
    if (scrollPosition === 0) {
      return;
    }

    if (currentPosition <= scrollPosition) {
      headerShipping.style.display = "none";
      main.style.marginTop = '144px';
    } else if (currentPosition > scrollPosition) {
      headerShipping.style.display = "block";
      main.style.marginTop = (144 + headerShipping.scrollHeight) + 'px';
    }
    currentPosition = document.documentElement.scrollTop;
  })
})
